import React from "react";
import { Switch, Route } from "react-router-dom";
import NotFound from "../NotFound";

import View from "./View";
import CreatePatient from "./Create";
import PatientProfile from "./PatientProfile";

import Navigation from "../../partials/navigation";

const Patient = ({ history }) => {
    return (
        <div className="page-wrapper">
            <Navigation history={history} />
            <div className="page-container">
                <div className="page-content-wrapper page-content-wrapper-home">
                    {/* Main navigation comes here */}
                    <div className="page-content page-content-home">
                        <Switch>
                            <Route exact path="/home/patient" component={View} />
                            <Route path="/home/patient/create" component={CreatePatient} />
                            <Route exact path="/home/patient/profile" component={PatientProfile} />
                            <Route path="/home/patient/profile/:id" component={PatientProfile} />
                            <Route component={NotFound} />
                        </Switch>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Patient;
